import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'

const state = {
  successMessage: null,
  errorMessage: null,
  notifications: null
}

const getters = {
  successMessage: state => state.successMessage,
  errorMessage: state => state.errorMessage,
  notifications: state => state.notifications
}

const mutations = {
  setSuccessMessage: (state, payload) => {
    state.successMessage = payload
  },
  setErrorMessage: (state, payload) => {
    state.errorMessage = payload
  },
  setNotifications: (state, payload) => {
    state.notifications = payload
  }
}

const actions = {
  setSuccessMessage ({commit}, value) {
    commit('setSuccessMessage', value)
  },
  setErrorMessage ({commit}, value) {
    commit('setErrorMessage', value)
  },
  addNotification ({commit}, payload) {
    store.dispatch('setLoaderStatus', true)
    fb.addNotification(payload.text, payload.to, payload.from)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Your comments sent successfully')
      })
  },
  getNotifications ({commit}) {
    store.dispatch('setLoaderStatus', true)
    fb.getNotifications()
      .then((fetched) => {
        store.dispatch('setLoaderStatus', false)
        commit('setNotifications', getDocsFromCollection(fetched))
      })
  },
  updateNotification ({commit}, params) {
    store.dispatch('setLoaderStatus', true)
    fb.updateNotification(params.id, params.payload)
      .then((response) => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Your comments updated successfully')
        store.dispatch('getNotifications')
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js